import DesktopVoucherBadge from "./components/DesktopVoucherBadge/DesktopVoucherBadge";
import MWebVoucherBadge from "./components/MWebVoucherBadge/MWebVoucherBadge";

export { DesktopVoucherBadge, MWebVoucherBadge };
